import { useTranslation } from "react-i18next";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

function InstuctionsPage(){
  const {t} = useTranslation();
  const inProduction = process.env.REACT_APP_ENV === "production";

  return(
    <div className="container-fluid">
      <div className="row">
        {inProduction &&
          <div className="col px-4 px-lg-5 py-4 mt-3 mb-5 my-md-4 my-xl-5 ohjeBox">
            <h2 id="firtsHeader" className="">{t("instructions.1stHeader")}</h2>
            <p className="">{t("instructions.1stParagraph")}</p>
            <h2 id="secondHeader" className="">{t("instructions.2ndHeader")}</h2>
            <p className="">{t("instructions.2ndParagraph")}</p>
            <h2 id="thirdHeader" className="">{t("instructions.3rdHeader")}</h2>
            <p className="">{t("instructions.3rdParagraph")}</p>
            <h2 id="fourthHeader" className="">{t("instructions.3rdHeader")}</h2>
            <p className="">{t("instructions.3rdParagraph")}</p>
            <h2 id="fiftHeader" className="">{t("instructions.3rdHeader")}</h2>
            <p className="">{t("instructions.3rdParagraph")}</p>
            <h2 id="sixthHeader" className="">{t("instructions.3rdHeader")}</h2>
            <p className="">{t("instructions.3rdParagraph")}</p>
            <h2 id="seventhHeader" className="">{t("instructions.3rdHeader")}</h2>
            <p className="">{t("instructions.3rdParagraph")}</p>
          </div>
        }
      </div>
    </div>
  );
};

export default InstuctionsPage;
